cb.define([], function (common) {
  var ST_st_storecheckrealitylist_FilterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      viewmodel.on('afterInit', function () {
        var currentDate = new Date().format('yyyy-MM-dd');
        viewmodel.get('vouchdate').getFromModel().setValue(getFirstDayOfCurrentMonth());
        viewmodel.get('vouchdate').getToModel().setValue(currentDate);

        //业务类型过滤条件
        var conditionBustype = {
          "isExtend": true,
          simpleVOs: []
        };
        conditionBustype.simpleVOs.push({
          field: 'receipttype.code',
          op: 'eq',
          value1: 'A13'
        });
        viewmodel.get('businesstype').getFromModel().setFilter(conditionBustype);
        //出入库仓库过滤条件
        var conditionBustype = {
          "isExtend": true,
          simpleVOs: []
        };

      });

      var getFirstDayOfCurrentMonth = function () {
        var firstDate = new Date();
        firstDate.setDate(1); //第一天
        return firstDate.format('yyyy-MM-dd');
      };

      viewmodel.on("beforeSearch", function(condition) {
        //两次，第一次是获取到实盘单列表的viewmodel，继续获取父亲，才获取到盘点计划的viewmodel
        var parentViewModel = viewmodel.getCache('parentViewModel').getCache('parentViewModel');
        if(!condition.simpleVOs){
          condition.simpleVOs=[];
        }
        condition.simpleVOs.push({
          field: 'storecheckplan',
          op: 'eq',
          value1: parentViewModel.get('id').getValue()
        });
        condition['isExtend']=true;
      });


    }
  };
  try {
    module.exports = ST_st_storecheckrealitylist_FilterVM_Extend;
  } catch (error) {

  }
  return ST_st_storecheckrealitylist_FilterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckrealitylist_FilterVM.Extend.js